import React, { createContext, useContext, useMemo } from 'react'

export const StaticProps = createContext()

export function StaticPropsProvider({ children, value }) {
  const staticProps = useMemo(() => value, [value])

  return (
    <StaticProps.Provider value={staticProps}>
      {children}
    </StaticProps.Provider>
  )
}

export const useStaticProps = () => useContext(StaticProps)
